import { render, staticRenderFns } from "./goods-type-list.vue?vue&type=template&id=603a3b50&"
import script from "./goods-type-list.vue?vue&type=script&lang=js&"
export * from "./goods-type-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports